import { getBusiness, getUser, updateUser } from "../../services/auth.service";
import { toast } from "react-toastify";
import {
  getBuys,
  createBuy,
  getInventoryProducts,
  getWarehouseProducts,
} from "../../services/buy.service";
import { getCustomer } from "../../services/customer.service";
import { getStatsData } from "../../services/dashboard.service";
import { getEmployee,getDashboardStats,getTodayAttendance} from "../../services/employee.service";
import { getExpenses } from "../../services/expenses";
import {
  createProducts,
  getProducts,
  getServices,
  getRawmatrial,
  updateRawMaterialService,
  deleteRawMaterialService,
  updateVariant,
  deleteVariant,
  saveProductVariants,
  getVariantOptions
} from "../../services/inventory.service";
import {
  createSale,
  getSales,
  delivarydata,
} from "../../services/sale.service";
import {
  getAllPurchaseReturnService,
  getReturns,
  createReturn,
} from "../../services/return.service";
import { getSuplier } from "../../services/supplier.service";
import { getAllLists, getAllTodosTasks } from "../../services/task.service";
import {
  setBuyIsLoading,
  setBuys,
  setProducts,
  setPurchaseReturns,
  setTempBuys,
  setTempPurchaseReturn,
  addBuy,
  setBuyReturnPagination,
  setBuyPagination,
  setWarehouseProducts,
  setWarehouseProductsLoading,
} from "../reducers/buyReducer";
import {
  setReturns,
  setSaleIsLoading,
  setSales,
  setTempReturn,
  setTempSales,
  addSale,
  setDeliveryData,
  setDeliveryIsLoading,
  setSaleReturnPagination,
  setSalePagination,
} from "../reducers/saleReducer";
import {
  setCustomerIsLoading,
  setCustomerPagination,
  setCustomers,
  setTempCustomers,
} from "../reducers/customerReducer";
import {
  setDashboardIsLoading,
  setStates,
  setTasks,
  setDashboardError,
} from "../reducers/dashboardReducer";
import {
  setEmployeeIsLoading,
  setEmployeePagination,
  setEmployees,
  setTempEmployees,
  setDashboardStats,
  setTodayAttendance,

} from "../reducers/employeeReducer";

import {
  setExpenseIsLoading,
  setExpensePagination,
  setExpenses,
  setTempExpenses,
} from "../reducers/expenseReducer";
import {
  setInventory,
  setInventoryIsLoading,
  setInventoryIsLoadingFalse,
  setProductsPagination,
  setServicePagination,
  setTempProducts,
  setTempServices,
  setRawMaterialsPagination,
  setTempRawMaterials,
  resetVariantSelection,
  setSelectedQuantity,
  setSelectedVariant,
  setAvailableVariants,
  setVariantSelectionLoading,
  setVariantSelectionError,
  
} from "../reducers/inventoryReducer";
import { setListIsLoading, setLists } from "../reducers/listReducer";

import {
  setSupplierIsLoading,
  setSupplierPagination,
  setSuppliers,
  setTempSuppliers,
} from "../reducers/supplierReducer";
import { setUserLoading, updateUsers } from "../reducers/userReducer";
import {
  setCashBookIsLoading,
  setCashBooks,
  setCashBooksPagination,
  setTempCashBooks,
} from "../reducers/cashBookReducer";
import { getAlltransaction } from "../../services/cashbook.services";
import {
  setIncome,
  setIncomeIsLoading,
  setIncomePagination,
  setTempIncome,
} from "../reducers/incomeReducer";
import { getIncomeService } from "../../services/incomeServices";
import {
  setCredit,
  setCreditIsLoading,
  setCreditPagination,
  setDebit,
  setDebitIsLoading,
  setDebitPagination,
  setTempCredit,
  setTempDebit,
} from "../reducers/debitCreditReducer";
import {
  getCreditNotes,
  getDebitNotes,
} from "../../services/debitCredit.service";
import { getBusines, setBusinessLoading } from "../reducers/bussinessReducer";

import {
  getAllTickets,
  addTicketNoteService,
} from "../../services/ticket.service";
import {
  fetchTicketsStart,
  fetchTicketsSuccess,
  fetchTicketsFailure,
  addNoteToTicket,
} from "../reducers/ticketReducer";

import {
  initializePermissions,
  getAllRolePermissions,
  updateRolePermissions,
  getUserAllowedRoutes,
} from "../../services/rolePermission.service";
import {
  setPermissions,
  setAllowedRoutes,
  setLoading,
  setError,
} from "../reducers/rolePermissionReducer";


import {
  PandLReportBasicFormat,
  fetchInventoryData,
  PnlBasic,
  PnlTrend,
  PnlCustomerPending,
  getSupplierPending,
  customeSalesReport,
  customePurchaseReport,
  getInventoryReport,
  getExpenseReport,
  getCustomerReport,
  getSupplierReport,
  getExpenseTrendReport,
  getSalesTrendReport,
  getSaleReportByPercent,
  getTrendReport,
  getSalesInvoiceReport,
  getReturnTrendReport,
  getReturnByPercentageReport,
  getCustomerReportcustomer,
  getPurchaseDetailedReport,
  getPurchaseStatusDetailedReport,
  gstr1report,
  gstr2report,
  getRawMaterialDetailedReport,
  getManufaturingDetailedReport,
  getWarehouseStatusCountReport,
  getGSTR3BReport,
} from "../../services/report.service";

import {
  fetchPnLDataRequest,
  fetchPnLDataSuccess,
  fetchPnLDataFailure,
} from "../reducers/report/P&L Report - Basic Format.Reducer";
import {
  fetchInventoryRequest,
  fetchInventorySuccess,
  fetchInventoryFailure,
} from "../reducers/report/inventoryReoport";

import {
  BasicPnLDataRequest,
  BasicPnLDataSuccess,
  BasicPnLDataFailure,
} from "../reducers/report/PnlBasic";

import {
  PnlTrendRequest,
  PnlTrendSuccess,
  PnlTrendFailure,
} from "../reducers/report/PnlTrend";

import {
  CustomerPendingRequest,
  CustomerPendingSuccess,
  CustomerPendingFailure,
} from "../reducers/report/PnlCustomerPending";

import {
  supplierPendingRequest,
  supplierPendingSuccess,
  supplierPendingFailure,
} from "../reducers/report/pnlSupplierPending";

import {
  salesReportRequest,
  salesReportSuccess,
  salesReportFailure,
} from "../reducers/report/CustomeSaleReport";

import {
  purchesReportRequest,
  purchesReportSuccess,
  purchesReportFailure,
} from "../reducers/report/CustomePurchesReport";

import {
  inventoryReportRequest,
  inventoryReportSuccess,
  inventoryReportFailure,
} from "../reducers/report/CustomeInventoryReport";

import {
  expenseReportRequest,
  expenseReportSuccess,
  expenseReportFailure,
} from "../reducers/report/CustomeExpenseReport";

import {
  customerReportRequest,
  customerReportSuccess,
  customerReportFailure,
} from "../reducers/report/CustomeCustomerReport";

import {
  supplierReportRequest,
  supplierReportSuccess,
  supplierReportFailure,
} from "../reducers/report/CustomeSupplierReport";

import {
  fetchExpenseTrendRequest,
  fetchExpenseTrendSuccess,
  fetchExpenseTrendFailure,
} from "../reducers/report/ExpenseTrendReport";
import {
  salesTrendReportRequest,
  salesTrendReportSuccess,
  salesTrendReportFailure,
} from "../reducers/report/SaleReportSaleTrand";

import {
  saleReportByPercentRequest,
  saleReportByPercentSuccess,
  saleReportByPercentFailure,
} from "../reducers/report/SaleReportSaleReportByPercent";

import {
  trendReportRequest,
  trendReportSuccess,
  trendReportFailure,
} from "../reducers/report/SaleReportReporttrend";

import {
  salesInvoiceReportRequest,
  salesInvoiceReportSuccess,
  salesInvoiceReportFailure,
} from "../reducers/report/SaleReportInvoice";

import {
  returnTrendReportRequest,
  returnTrendReportSuccess,
  returnTrendReportFailure,
} from "../reducers/report/ReturnReportTrend";

import {
  returnPercentageReportRequest,
  returnPercentageReportSuccess,
  returnPercentageReportFailure,
} from "../reducers/report/ReturnPercentage";

import {
  customerPurchaseReportRequest,
  customerPurchaseReportSuccess,
  customerPurchaseReportFailure,
  // resetCustomerPurchaseReport,
} from "../reducers/report/CustomerReport";
import {
  purchaseReportRequest,
  purchaseReportSuccess,
  purchaseReportFailure,
} from "../reducers/report/PurchaseTreandReport";
import {
  purchaseStatusReportRequest,
  purchaseStatusReportSuccess,
  purchaseStatusReportFailure,
} from "../reducers/report/PurchaseStatusReport";
import {
  Gstr1ReportRequest,
  Gstr1ReportSuccess,
  Gstr1ReportFailure,
} from "../reducers/report/GstR1Report";
import {
  Gstr2ReportRequest,
  Gstr2ReportSuccess,
  Gstr2ReportFailure,
} from "../reducers/report/GstR2Report";
import {
  Gstr3BReportRequest,
  Gstr3BReportSuccess,
  Gstr3BReportFailure,
} from "../reducers/report/GstR3BReport";
import { setCouponLoading, setCoupons } from "../reducers/couponReducer.js";
import { getCoupons } from "../../services/coupon.service.js";
import { format } from "date-fns";
// Add these imports at the top with other imports
// store/actions/manufactureActions.js
import {
  getManufacturingOrders,
  createManufacturingOrder,
  updateManufacturingOrder,
  deleteManufacturingOrder,
  startManufacturing,
  completeManufacturing,
  getAvailableRawMaterials,
  getProductionEfficiency,
  getPendingProductions,
  getProductionsByStatus,
  performQualityCheck,
  holdManufacturing,
  resumeManufacturing,
  cancelManufacturing,
} from "../../services/manufacture.service";

import {
  setManufacturingOrders,
  setTempManufacturingOrders,
  setManufacturingPagination,
  setEfficiencyStats,
  setAvailableRawMaterials,
  setAvailableRawMaterialsLoading,
  addManufacturingOrder,
  updateManufacturingOrder as updateManufacturingOrderAction,
  deleteManufacturingOrder as deleteManufacturingOrderAction,
  setManufacturingIsLoading,
} from "../reducers/report/manufactureReducer";

import {
  updateRawMaterial,
  deleteRawMaterial,
  setRawMaterialsLoading,
  setRawMaterials,
} from "../reducers/rawMatrialReducer";

import {
  RawMaterialReportRequest,
  RawMaterialReportSuccess,
  RawMaterialReportFailure,
} from "../reducers/report/RawMatarialReport";
import {
  WarehouseReportRequest,
  WarehouseReportSuccess,
  WarehouseReportFailure,
} from "../reducers/report/WarehouseReport";
import {
  WarehouseStatusCountReportRequest,
  WarehouseStatusCountReportSuccess,
  WarehouseStatusCountReportFailure,
} from "../reducers/report/warehouseStatusCountReport.js";
import {
  getUserWishlist,
  getGuestWishlist,
  toggleUserWishlistItem,
  toggleGuestWishlistItem,
  checkUserWishlistItem,
  checkGuestWishlistItem,
  removeFromUserWishlist,
  removeFromGuestWishlist,
  clearUserWishlist,
  clearGuestWishlist,
  mergeWishlists,
} from "../../services/wishlist.service";
import {
  setWishlistItems,
  addToWishlist,
  removeFromWishlist,
  clearWishlist,
  setWishlistLoading,
  setWishlistProcessing,
  setWishlistError,
  setWishlistPagination,
  setWishlistStatus,
  setCheckingStatus,
  resetWishlistStatus,
  setMultipleWishlistStatus,
  resetWishlistState,
} from "../reducers/wishlistReducer";
// import { advanceOrderReportFailure, advanceOrderReportRequest, advanceOrderReportSuccess } from "../reducers/report/AdvanceOrderReport.js";
import {
  getInventoryDashboard,
  getPurchaseOrders,
  getFestivalForecast,
  getAlerts,
  getPurchaseRecommendation,
  getRecommendations,
  getInventoryHealth,
  getDeadStock,
  getExpiryPrediction,
  getSlowMoving,
  getFastMoving,
  getAbcAnalysis,
  getXyzAnalysis,
  getForecast,
  getPurchaseOrder,
  approvePurchaseOrder,
  rejectPurchaseOrder,
  receivePurchaseOrder,
} from "../../services/inventorydashboard.service";

import {
  setInventoryData,
  setLoading as setInventoryIntelligenceLoading,
  setError as setInventoryIntelligenceError,
  setPurchaseOrders,
  setAlerts,
  setRecommendations,
} from "../reducers/inventoryIntelligenceReducer";


const extractArray = (response) => {
  if (Array.isArray(response)) return response;
  if (response && typeof response === 'object') {
    if (Array.isArray(response.data)) return response.data;
    if (Array.isArray(response.items)) return response.items;
    if (Array.isArray(response.results)) return response.results;
  }
  return [];
};

// Helper to format dates
const formatDate = (dateValue) => {
  if (!dateValue) return 'N/A';
  const d = new Date(dateValue);
  if (isNaN(d.getTime())) return 'N/A';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};


export const fetchInventoryIntelligenceData = (businessUuid) => {
  return async (dispatch) => {
    if (!businessUuid) {
      dispatch(setInventoryIntelligenceError('Business UUID is missing'));
      return;
    }

    dispatch(setInventoryIntelligenceLoading(true));

    try {
      // 1. Dashboard (main)
      let dashboard = null;
      try {
        dashboard = await getInventoryDashboard(businessUuid);
        console.log('📊 Dashboard Response:', dashboard);
      } catch (err) {
        console.warn('Dashboard fetch failed:', err);
      }

      // 2. Purchase orders
      let purchaseOrders = [];
      try {
        const poData = await getPurchaseOrders(businessUuid);
        console.log('📦 Purchase Orders:', poData);
        purchaseOrders = extractArray(poData);
      } catch (poErr) {
        console.warn('Purchase orders not available:', poErr);
      }

      // 3. Alerts
      let alertsArray = [];
      try {
        const alertsResp = await getAlerts(businessUuid);
        console.log('🔔 Alerts Response:', alertsResp);
        alertsArray = extractArray(alertsResp);
      } catch (alertErr) {
        console.warn('Alerts not available:', alertErr);
      }

      // 4. Purchase recommendations (for reorder count)
      let recsArray = [];
      try {
        const recsResp = await getPurchaseRecommendation(businessUuid);
        console.log('🛒 Purchase Recommendations:', recsResp);
        recsArray = extractArray(recsResp);
      } catch (recErr) {
        console.warn('Purchase recommendations not available:', recErr);
      }

      // 5. Recommendations (Today's AI Actions)
      let actionsArray = [];
      try {
        const actionsResp = await getRecommendations(businessUuid);
        console.log('🎯 Recommendations Response:', actionsResp);
        actionsArray = extractArray(actionsResp);
      } catch (actionErr) {
        console.warn('Recommendations not available:', actionErr);
      }

      // 6. Festival
      let festivalData = [];
      try {
        const festResp = await getFestivalForecast(businessUuid);
        console.log('🎉 Festival Response:', festResp);
        festivalData = extractArray(festResp);
      } catch (festErr) {
        console.warn('Festival data not available:', festErr);
      }

      // 7. Individual data for additional insights
      let inventoryHealth = [];
      let deadStockList = [];
      let expiryList = [];
      let slowMovingList = [];
      let fastMovingList = [];
      let abcAnalysis = [];
      let xyzAnalysis = [];
      let forecast = [];

      try {
        const [health, dead, expiry, slow, fast, abc, xyz, forecastData] = await Promise.all([
          getInventoryHealth(businessUuid).catch(() => []),
          getDeadStock(businessUuid).catch(() => []),
          getExpiryPrediction(businessUuid).catch(() => []),
          getSlowMoving(businessUuid).catch(() => []),
          getFastMoving(businessUuid).catch(() => []),
          getAbcAnalysis(businessUuid).catch(() => []),
          getXyzAnalysis(businessUuid).catch(() => []),
          getForecast(businessUuid).catch(() => []),
        ]);
        inventoryHealth = extractArray(health);
        deadStockList = extractArray(dead);
        expiryList = extractArray(expiry);
        slowMovingList = extractArray(slow);
        fastMovingList = extractArray(fast);
        abcAnalysis = extractArray(abc);
        xyzAnalysis = extractArray(xyz);
        forecast = extractArray(forecastData);
      } catch (err) {
        console.warn('Some individual data fetches failed:', err);
      }

      // --- Process data ---
      const summary = dashboard?.summary || {};
      const details = dashboard?.details || {};

      const total = summary.products || inventoryHealth.length || 0;
      const deadCount = summary.deadStock !== undefined ? summary.deadStock : deadStockList.length;
      const expiryCount = summary.expiryRisk !== undefined ? summary.expiryRisk : expiryList.length;

      // For healthy/low calculation
      const deadProductIds = new Set(deadStockList.map(item => item.productId));
      const expiryProductIds = new Set(
        expiryList
          .filter(item => ['HIGH', 'CRITICAL', 'EXPIRED'].includes(item.risk))
          .map(item => item.productId)
      );

      let healthy = 0, low = 0;
      if (inventoryHealth.length > 0) {
        inventoryHealth.forEach(item => {
          const pid = item.productId;
          if (deadProductIds.has(pid) || expiryProductIds.has(pid)) return;
          const status = item.status || '';
          if (status === 'Excellent' || status === 'Good') {
            healthy++;
          } else {
            low++;
          }
        });
      } else {
        healthy = summary.healthy || 0;
        low = summary.lowStock || 0;
      }

      const pendingPO = purchaseOrders.filter(po => 
        po.status === 'PENDING_APPROVAL' || po.status === 'pending'
      ).length;

      const criticalAlerts = summary.criticalAlerts !== undefined 
        ? summary.criticalAlerts 
        : alertsArray.filter(a => a.severity === 'CRITICAL' || a.severity === 'HIGH').length;

      const reorderRequired = recsArray.filter(r => 
        r.decision === 'Purchase' && (r.priority === 'HIGH' || r.priority === 'CRITICAL')
      ).length;

      const kpi = {
        reorderRequired,
        deadStock: deadCount,
        expiryRisk: expiryCount,
        pendingPO,
        criticalAlerts,
        totalProducts: total,
        healthy,
        lowStock: low,
      };

      // Pie chart
      const totalForPie = healthy + low + deadCount + expiryCount || 1;
      const pieData = {
        healthy: Math.round((healthy / totalForPie) * 100),
        low: Math.round((low / totalForPie) * 100),
        dead: Math.round((deadCount / totalForPie) * 100),
        expiry: Math.round((expiryCount / totalForPie) * 100),
      };

      // Forecast
      const forecastDataMapped = forecast.slice(0, 5).map(item => ({
        name: item.productName || 'Item',
        semester1: item.forecast?.day_30 || 0,
        semester2: 0,
      }));

      // Category-wise: ABC
      const catMap = {};
      abcAnalysis.forEach(item => {
        const cat = item.category || 'Other';
        catMap[cat] = (catMap[cat] || 0) + 1;
      });
      const categoryData = Object.entries(catMap)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 3)
        .map(([name, count]) => ({ name, count }));

      // Stock trend
      let stockTrend = [];
      if (forecast.length > 0) {
        const weeks = ['W1', 'W2', 'W3', 'W4', 'W5'];
        const values = forecast.slice(0, 5).map((item) => {
          const val = item.forecast?.day_30 || 0;
          return Math.round((val / 30) * 10) % 20 + 5;
        });
        stockTrend = weeks.map((week, i) => ({ week, value: values[i] || 0 }));
      } else {
        stockTrend = [
          { week: 'W1', value: 0 },
          { week: 'W2', value: 0 },
          { week: 'W3', value: 0 },
          { week: 'W4', value: 0 },
          { week: 'W5', value: 0 },
        ];
      }

      // Today's AI Actions
      let todayActions = [];
      if (actionsArray.length > 0) {
        todayActions = actionsArray.slice(0, 4).map(rec => ({
          title: rec.title || rec.productName || 'Product',
          description: rec.message || 'Recommendation',
          action: 'Act',
          type: rec.type ? rec.type.toLowerCase() : 'default',
        }));
      } else {
        if (recsArray.length > 0) {
          todayActions = recsArray.slice(0, 4).map(rec => ({
            title: rec.productName || 'Product',
            description: rec.reason || 'Purchase recommendation',
            action: 'Act',
            type: 'default',
          }));
        }
      }

      // Recent alerts
      let recentAlerts = [];
      if (alertsArray.length > 0) {
        recentAlerts = alertsArray.slice(0, 3).map(alert => ({
          message: alert.message_en || alert.message || 'Alert',
          time: alert.updatedAt ? formatDate(alert.updatedAt) : 'Just now',
          severity: alert.severity ? alert.severity.toLowerCase() : 'info',
          actionLabel: 'Review',
          id: alert._id,
        }));
      }

      // Dispatch final data
      dispatch(setInventoryData({
        kpi,
        forecastData: forecastDataMapped,
        pieData,
        categoryData,
        stockTrend,
        todayActions,
        recentAlerts,
        festivalData,
        dashboardDetails: details,
        purchaseOrders,
        alertsArray,
        inventoryHealth,
        deadStockList,
        expiryList,
        slowMovingList,
        fastMovingList,
        abcAnalysis,
        xyzAnalysis,
        purchaseRecommendations: recsArray,
        recommendations: actionsArray,
        forecast,
      }));

    } catch (error) {
      console.error('Error in fetchInventoryIntelligenceData:', error);
      dispatch(setInventoryIntelligenceError(error.message || 'Failed to load inventory intelligence data'));
    }
  };
};

// ========================================
// Individual Data Fetch Actions
// ========================================

export const fetchPurchaseOrders = (businessUuid, status = null) => {
  return async (dispatch) => {
    try {
      const data = await getPurchaseOrders(businessUuid, status);
      const orders = extractArray(data);
      dispatch(setPurchaseOrders(orders));
      return orders;
    } catch (error) {
      console.error('Error fetching purchase orders:', error);
      throw error;
    }
  };
};

export const fetchAlerts = (businessUuid) => {
  return async (dispatch) => {
    try {
      const data = await getAlerts(businessUuid);
      const alerts = extractArray(data);
      dispatch(setAlerts(alerts));
      return alerts;
    } catch (error) {
      console.error('Error fetching alerts:', error);
      throw error;
    }
  };
};

export const fetchRecommendations = (businessUuid) => {
  return async (dispatch) => {
    try {
      const data = await getRecommendations(businessUuid);
      const recs = extractArray(data);
      dispatch(setRecommendations(recs));
      return recs;
    } catch (error) {
      console.error('Error fetching recommendations:', error);
      throw error;
    }
  };
};

// ========================================
// Purchase Order Actions
// ========================================

export const fetchPurchaseOrderDetails = (businessUuid, purchaseOrderUuid) => {
  return async () => {
    try {
      const data = await getPurchaseOrder(businessUuid, purchaseOrderUuid);
      return data;
    } catch (error) {
      console.error('Error fetching purchase order details:', error);
      throw error;
    }
  };
};

export const approvePurchaseOrderAction = (businessUuid, purchaseOrderUuid, approvedBy) => {
  return async (dispatch) => {
    try {
      const result = await approvePurchaseOrder(businessUuid, purchaseOrderUuid, approvedBy);
      // Refresh purchase orders after approval
      await dispatch(fetchPurchaseOrders(businessUuid));
      toast.success('Purchase order approved successfully');
      return result;
    } catch (error) {
      console.error('Error approving purchase order:', error);
      toast.error(error.message || 'Failed to approve purchase order');
      throw error;
    }
  };
};

export const rejectPurchaseOrderAction = (businessUuid, purchaseOrderUuid, rejectedBy, reason) => {
  return async (dispatch) => {
    try {
      const result = await rejectPurchaseOrder(businessUuid, purchaseOrderUuid, rejectedBy, reason);
      // Refresh purchase orders after rejection
      await dispatch(fetchPurchaseOrders(businessUuid));
      toast.success('Purchase order rejected');
      return result;
    } catch (error) {
      console.error('Error rejecting purchase order:', error);
      toast.error(error.message || 'Failed to reject purchase order');
      throw error;
    }
  };
};

export const receivePurchaseOrderAction = (businessUuid, purchaseOrderUuid, receivedBy) => {
  return async (dispatch) => {
    try {
      const result = await receivePurchaseOrder(businessUuid, purchaseOrderUuid, receivedBy);
      // Refresh purchase orders after receiving
      await dispatch(fetchPurchaseOrders(businessUuid));
      toast.success('Purchase order received successfully');
      return result;
    } catch (error) {
      console.error('Error receiving purchase order:', error);
      toast.error(error.message || 'Failed to receive purchase order');
      throw error;
    }
  };
};

// ========================================
// EXISTING ACTIONS (kept as is)
// ========================================

// Helper to get user profile from localStorage
const getUserProfile = (businessUuid) => {
  try {
    const savedUser = localStorage.getItem(`user_${businessUuid}`);
    const savedGuest = localStorage.getItem(`guest_${businessUuid}`);
    return savedUser
      ? JSON.parse(savedUser)
      : savedGuest
        ? JSON.parse(savedGuest)
        : null;
  } catch (error) {
    console.error('Error parsing user profile:', error);
    return null;
  }
};

// Helper to check if user is logged in
const isUserLoggedIn = (businessUuid) => {
  const userProfile = getUserProfile(businessUuid);
  return userProfile && !userProfile.isGuest;
};

// Helper to create wishlist item key
const createWishlistKey = (productId, variantId = null) => {
  return `${productId}_${variantId || 'null'}`;
};

// Fetch wishlist
export const fetchWishlist = (businessUuid, params = {}) => {
  return async (dispatch) => {
    if (!businessUuid) {
      dispatch(setWishlistError('Business UUID is required'));
      return { success: false };
    }

    dispatch(setWishlistLoading(true));
    dispatch(setWishlistError(null));

    try {
      const isLoggedIn = isUserLoggedIn(businessUuid);
      let response;

      if (isLoggedIn) {
        const userProfile = getUserProfile(businessUuid);
        const customerId = userProfile?.customerId || userProfile?._id;
        
        if (!customerId) {
          throw new Error('Customer ID not found');
        }
        
        response = await getUserWishlist(businessUuid, customerId, params.signal);
      } else {
        response = await getGuestWishlist(businessUuid, params.signal);
      }

      if (response && response.success) {
        const items = response.data?.items || [];
        dispatch(setWishlistItems(items));
        
        // Update wishlist status map
        const statusMap = {};
        items.forEach(item => {
          const key = createWishlistKey(item.productId, item.variantId);
          statusMap[key] = true;
        });
        dispatch(setMultipleWishlistStatus(statusMap));
        
        if (response.data?.pagination) {
          dispatch(setWishlistPagination(response.data.pagination));
        }
        
        return { success: true, data: items };
      } else {
        dispatch(setWishlistItems([]));
        if (response?.error === 'canceled') {
          return { success: false, canceled: true };
        }
        throw new Error(response?.message || 'Failed to fetch wishlist');
      }
    } catch (error) {
      if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
        return { success: false, canceled: true };
      }
      
      console.error('Error fetching wishlist:', error);
      dispatch(setWishlistError(error.message || 'Failed to fetch wishlist'));
      dispatch(setWishlistItems([]));
      return { success: false, error: error.message };
    } finally {
      dispatch(setWishlistLoading(false));
    }
  };
};

// Check wishlist status for a single item
export const checkWishlistItem = (businessUuid, productId, variantId = null, signal = null) => {
  return async (dispatch) => {
    if (!businessUuid || !productId) {
      return { success: false, exists: false };
    }

    const key = createWishlistKey(productId, variantId);
    dispatch(setCheckingStatus({ key, status: true }));

    try {
      const isLoggedIn = isUserLoggedIn(businessUuid);
      let response;

      if (isLoggedIn) {
        const userProfile = getUserProfile(businessUuid);
        const customerId = userProfile?.customerId || userProfile?._id;
        
        if (!customerId) {
          throw new Error('Customer ID not found');
        }
        
        response = await checkUserWishlistItem(
          businessUuid,
          customerId,
          productId,
          variantId,
          signal
        );
      } else {
        response = await checkGuestWishlistItem(
          businessUuid,
          productId,
          variantId,
          signal
        );
      }

      if (response && response.success) {
        const exists = response.exists || false;
        dispatch(setWishlistStatus({ key, status: exists }));
        return { success: true, exists };
      }
      
      return { success: false, exists: false };
    } catch (error) {
      if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
        return { success: false, exists: false };
      }
      console.error('Error checking wishlist item:', error);
      return { success: false, exists: false };
    } finally {
      dispatch(setCheckingStatus({ key, status: false }));
    }
  };
};

// Toggle wishlist item
export const toggleWishlistItem = (businessUuid, product, selectedVariant = null) => {
  return async (dispatch) => {
    if (!businessUuid || !product?.productId) {
      toast.error('Missing required information');
      return { success: false };
    }

    dispatch(setWishlistProcessing(true));

    try {
      const variantId = selectedVariant?.variantId || null;
      const key = createWishlistKey(product.productId, variantId);
      
      const wishlistItem = {
        productId: product.productId,
        variantId: variantId,
        variantKey: selectedVariant?.variantKey || null,
        variantAttributes: selectedVariant?.variantAttributes || [],
        productName: product.productName,
        salePrice: selectedVariant?.salePrice || product.salePrice || "0",
        b2bSalePrice: product.b2bSalePrice || 0,
        image: selectedVariant?.itemPicture || product.itemPicture,
        sku_number: product.sku_number || '',
        weight: product.weight || 0.5,
        taxable_v: product.taxable_v || 'non-gst',
        cgst: product.cgst || 0,
        sgst_utgst: product.sgst_utgst || 0,
        igst: product.igst || 0,
        cess: product.cess || 0,
        isB2B: localStorage.getItem('b2b_Price') === 'true',
        variantName: selectedVariant?.variantName || null,
        variantSku: selectedVariant?.sku || selectedVariant?.variantSku || null,
        variantStock: selectedVariant?.quantity || 0,
        variantSalePrice: selectedVariant?.salePrice || 0,
        variantPurchasePrice: selectedVariant?.purchasePrice || 0,
        variantMrp: selectedVariant?.mrp || 0,
        variantBatchNumber: selectedVariant?.batchNumber || null,
        hasVariants: product.hasVariants || false,
        quantity: selectedVariant?.quantity || product.quantity || 0,
        mrp: selectedVariant?.mrp || product.mrp || 0,
        itemPicture: selectedVariant?.itemPicture || product.itemPicture,
      };

      const isLoggedIn = isUserLoggedIn(businessUuid);
      let response;

      if (isLoggedIn) {
        const userProfile = getUserProfile(businessUuid);
        const customerId = userProfile?.customerId || userProfile?._id;
        
        if (!customerId) {
          throw new Error('Customer ID not found');
        }
        
        response = await toggleUserWishlistItem(businessUuid, customerId, wishlistItem);
      } else {
        response = await toggleGuestWishlistItem(businessUuid, wishlistItem);
      }

      if (response && response.success) {
        const currentStatus = await dispatch(checkWishlistItem(businessUuid, product.productId, variantId));
        const isNowInWishlist = currentStatus.exists;
        
        if (isNowInWishlist) {
          dispatch(addToWishlist(wishlistItem));
          toast.success('Added to wishlist');
        } else {
          dispatch(removeFromWishlist({ productId: product.productId, variantId }));
        }
        
        return { success: true, isInWishlist: isNowInWishlist };
      } else {
        throw new Error(response?.message || 'Failed to update wishlist');
      }
    } catch (error) {
      console.error('Error toggling wishlist:', error);
      const isLoggedIn = isUserLoggedIn(businessUuid);
      if (!isLoggedIn) {
        toast.error('Login required to add items to wishlist');
      } else {
        toast.error(error.message || 'Failed to update wishlist');
      }
      return { success: false, error: error.message };
    } finally {
      dispatch(setWishlistProcessing(false));
    }
  };
};

// Remove item from wishlist
export const removeWishlistItem = (businessUuid, productId, variantId = null) => {
  return async (dispatch) => {
    if (!businessUuid || !productId) {
      toast.error('Missing required information');
      return { success: false };
    }

    dispatch(setWishlistProcessing(true));

    try {
      const isLoggedIn = isUserLoggedIn(businessUuid);
      let response;

      if (isLoggedIn) {
        const userProfile = getUserProfile(businessUuid);
        const customerId = userProfile?.customerId || userProfile?._id;
        
        if (!customerId) {
          throw new Error('Customer ID not found');
        }
        
        response = await removeFromUserWishlist(businessUuid, customerId, productId, variantId);
      } else {
        response = await removeFromGuestWishlist(businessUuid, productId, variantId);
      }

      if (response && response.success) {
        dispatch(removeFromWishlist({ productId, variantId }));
        const key = createWishlistKey(productId, variantId);
        dispatch(resetWishlistStatus(key));
        return { success: true };
      } else {
        throw new Error(response?.message || 'Failed to remove item');
      }
    } catch (error) {
      console.error('Error removing from wishlist:', error);
      toast.error(error.message || 'Failed to remove item');
      return { success: false, error: error.message };
    } finally {
      dispatch(setWishlistProcessing(false));
    }
  };
};

// Clear wishlist
export const clearWishlistItems = (businessUuid) => {
  return async (dispatch) => {
    if (!businessUuid) {
      toast.error('Business UUID is required');
      return { success: false };
    }

    dispatch(setWishlistProcessing(true));

    try {
      const isLoggedIn = isUserLoggedIn(businessUuid);
      let response;

      if (isLoggedIn) {
        const userProfile = getUserProfile(businessUuid);
        const customerId = userProfile?.customerId || userProfile?._id;
        
        if (!customerId) {
          throw new Error('Customer ID not found');
        }
        
        response = await clearUserWishlist(businessUuid, customerId);
      } else {
        response = await clearGuestWishlist(businessUuid);
      }

      if (response && response.success) {
        dispatch(clearWishlist());
        dispatch(setMultipleWishlistStatus({}));
        return { success: true };
      } else {
        throw new Error(response?.message || 'Failed to clear wishlist');
      }
    } catch (error) {
      console.error('Error clearing wishlist:', error);
      toast.error(error.message || 'Failed to clear wishlist');
      return { success: false, error: error.message };
    } finally {
      dispatch(setWishlistProcessing(false));
    }
  };
};

// Merge wishlists after login
export const mergeUserWishlists = (businessUuid, customerId) => {
  return async (dispatch) => {
    if (!businessUuid || !customerId) {
      return { success: false };
    }

    dispatch(setWishlistProcessing(true));

    try {
      const response = await mergeWishlists(businessUuid, customerId);

      if (response && response.success) {
        await dispatch(fetchWishlist(businessUuid));
        toast.success('Wishlists merged successfully');
        return { success: true, data: response.data };
      } else {
        throw new Error(response?.message || 'Failed to merge wishlists');
      }
    } catch (error) {
      console.error('Error merging wishlists:', error);
      return { success: false, error: error.message };
    } finally {
      dispatch(setWishlistProcessing(false));
    }
  };
};

// Check multiple items wishlist status
export const checkMultipleWishlistItems = (businessUuid, items) => {
  return async (dispatch) => {
    if (!businessUuid || !items || !items.length) {
      return { success: false };
    }

    const results = {};
    const promises = items.map(async ({ productId, variantId = null }) => {
      const key = createWishlistKey(productId, variantId);
      try {
        const result = await dispatch(checkWishlistItem(businessUuid, productId, variantId));
        results[key] = result.exists || false;
      } catch (error) {
        results[key] = false;
      }
    });

    await Promise.all(promises);
    dispatch(setMultipleWishlistStatus(results));
    return { success: true, results };
  };
};

// ========================================
// EXISTING REPORT ACTIONS
// ========================================

export const fetchWarehouseStatusCountReport = (businessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(WarehouseStatusCountReportRequest());
    try {
      const response = await getWarehouseStatusCountReport(
        businessUuid,
        params
      );

      if (response.status !== 200 && response.status !== 201) {
        throw new Error(`API responded with status ${response.status}`);
      }

      const payload = response.data;

      if (payload && payload.success !== false) {
        const dataToDispatch = payload.data || payload;
        dispatch(WarehouseStatusCountReportSuccess(dataToDispatch));
      } else {
        throw new Error(
          payload?.message || "API returned invalid or unsuccessful data"
        );
      }
    } catch (error) {
      console.error("Error fetching warehouse status count report:", error);
      dispatch(
        WarehouseStatusCountReportFailure(error.message || "An error occurred")
      );
    }
  };
};

export const fetchWarehouseReport = (businessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(WarehouseReportRequest());
    try {
      const response = await getManufaturingDetailedReport(
        businessUuid,
        params
      );

      if (response.status !== 200 && response.status !== 201) {
        throw new Error(`API responded with status ${response.status}`);
      }

      const payload = response.data;

      if (payload && payload.success !== false) {
        const dataToDispatch = payload.data || payload;
        dispatch(WarehouseReportSuccess(dataToDispatch));
      } else {
        throw new Error(
          payload?.message || "API returned invalid or unsuccessful data"
        );
      }
    } catch (error) {
      console.error("Error fetching warehouse report:", error);
      dispatch(WarehouseReportFailure(error.message || "An error occurred"));
    }
  };
};

export const fetchRawMaterialReport = (businessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(RawMaterialReportRequest());
    try {
      const response = await getRawMaterialDetailedReport(businessUuid, params);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error(`API responded with status ${response.status}`);
      }

      const payload = response.data;

      if (payload && payload.success !== false) {
        const dataToDispatch = payload.data || payload;
        dispatch(RawMaterialReportSuccess(dataToDispatch));
      } else {
        throw new Error(
          payload?.message || "API returned invalid or unsuccessful data"
        );
      }
    } catch (error) {
      console.error("Error fetching raw material report:", error);
      dispatch(RawMaterialReportFailure(error.message || "An error occurred"));
    }
  };
};


export const getRawMaterialsData = (businessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setRawMaterialsLoading(true));
    try {
      const result = await getRawmatrial(businessId, params);
      if (result.status === 200) {
        dispatch(setRawMaterials(result.data));
      }
    } catch (error) {
      console.error("Error fetching raw materials:", error);
      dispatch(setRawMaterialsLoading(false));
    }
  };
};

export const holdManufacturingProcess = (
  businessId,
  manufacturingId,
  reason,
  heldBy = "System"
) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await holdManufacturing(
        businessId,
        manufacturingId,
        reason,
        heldBy
      );
      if (result.status === 200) {
        if (result.data && result.data.data) {
          dispatch(
            updateManufacturingOrderInState(manufacturingId, result.data.data)
          );
        }
        dispatch(setManufacturingIsLoading(false));
        return result.data;
      }
    } catch (error) {
      console.error("Error holding manufacturing:", error);
      dispatch(setManufacturingIsLoading(false));
      throw error;
    }
  };
};

export const cancelManufacturingProcess = (
  businessId,
  manufacturingId,
  cancellationData = {}
) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await cancelManufacturing(
        businessId,
        manufacturingId,
        cancellationData
      );
      if (result.status === 200) {
        dispatch(setManufacturingIsLoading(false));
        return result.data;
      }
    } catch (error) {
      console.error("Error cancelling manufacturing:", error);
      dispatch(setManufacturingIsLoading(false));
      throw error;
    }
  };
};

export const resumeManufacturingProcess = (businessId, manufacturingId) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await resumeManufacturing(businessId, manufacturingId);
      if (result.status === 200) {
        if (result.data && result.data.data) {
          dispatch(
            updateManufacturingOrderInState(manufacturingId, result.data.data)
          );
        }
        dispatch(setManufacturingIsLoading(false));
        return result.data;
      }
    } catch (error) {
      console.error("Error resuming manufacturing:", error);
      dispatch(setManufacturingIsLoading(false));
      throw error;
    }
  };
};

// Enhanced update manufacturing order in state function
export const updateManufacturingOrderInState = (
  manufacturingId,
  updatedOrder
) => {
  return (dispatch, getState) => {
    const state = getState();
    const manufacturingOrders = state.manufacturing.manufacturingOrders || [];
    const index = manufacturingOrders.findIndex(
      (order) => order.manufacturingId === manufacturingId
    );

    if (index !== -1) {
      dispatch(updateManufacturingOrderAction({ index, order: updatedOrder }));
    }
  };
};

export const getManufacturingOrdersData = (businessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await getManufacturingOrders(businessId, params);
      if (result.status === 200) {
        dispatch(setManufacturingOrders(result.data.data));
        dispatch(setTempManufacturingOrders(result.data.data));
        dispatch(setManufacturingPagination(result.data.pagination));
      }
    } catch (error) {
      console.error("Error fetching manufacturing orders:", error);
      dispatch(setManufacturingIsLoading(false));
    }
  };
};

export const getEmployeeDashboardData = (businessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setEmployeeIsLoading(true));
    try {
      const result = await getEmployee(businessId, { 
        limit: 1000 
      });
      
      if (result.status === 200) {
        dispatch(setEmployees(result.data.data));
        dispatch(setTempEmployees(result.data.data));
        dispatch(setEmployeePagination(result.data.pagination));
      }

      if (typeof getDashboardStats === 'function') {
        const statsRes = await getDashboardStats(businessId);
        if (statsRes?.status === 200 && statsRes.data) {
          dispatch(setDashboardStats(statsRes.data));
        }
      }

      if (typeof getTodayAttendance === 'function') {
        const attendanceRes = await getTodayAttendance(businessId);
        if (attendanceRes?.status === 200) {
          let attendanceData = [];
          if (Array.isArray(attendanceRes.data)) {
            attendanceData = attendanceRes.data;
          } else if (attendanceRes.data?.employees) {
            attendanceData = attendanceRes.data.employees;
          } else if (attendanceRes.data?.attendance) {
            attendanceData = attendanceRes.data.attendance;
          }
          dispatch(setTodayAttendance(attendanceData));
        }
      }

      console.log("Employee Dashboard API Response:", result);
      
    } catch (error) {
      console.error("Error fetching employee dashboard data:", error);
    } finally {
      dispatch(setEmployeeIsLoading(false));
    }
  };
};



export const performQualityCheckData = (
  businessId,
  manufacturingId,
  qualityCheckData
) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await performQualityCheck(
        businessId,
        manufacturingId,
        qualityCheckData
      );
      if (result.status === 200) {
        if (result.data && result.data.data) {
          dispatch(
            updateManufacturingOrderInState(manufacturingId, result.data.data)
          );
        }
        dispatch(setManufacturingIsLoading(false));
        return result.data;
      }
    } catch (error) {
      console.error("Error performing quality check:", error);
      dispatch(setManufacturingIsLoading(false));
      throw error;
    }
  };
};

export const updateRawMaterialAction =
  (businessId, rawMaterialId, payload) => async (dispatch, getState) => {
    try {
      dispatch(setRawMaterialsLoading(true));
      const response = await updateRawMaterialService(
        businessId,
        rawMaterialId,
        payload
      );

      const updatedRawMaterial = response.data;

      const state = getState();
      const index = state.RawMatarial.rawMaterials.findIndex(
        (rm) => rm.rawMaterialId === rawMaterialId
      );

      if (index !== -1) {
        dispatch(updateRawMaterial({ index, rawMaterial: updatedRawMaterial }));
      }
      toast.success("Raw material updated successfully");
      return updatedRawMaterial;
    } catch (error) {
      toast.error("Failed to update raw material");
      console.error("Update raw material error:", error);
      return null;
    } finally {
      dispatch(setRawMaterialsLoading(false));
    }
  };

export const createManufacturingOrderData = (businessId, data) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      console.log("Creating manufacturing order with data:", data);

      const result = await createManufacturingOrder(businessId, data);
      console.log("API Response:", result);

      if (result.status === 201 || result.status === 200) {
        if (result.data && result.data.data) {
          dispatch(addManufacturingOrder(result.data.data));
          dispatch(getManufacturingOrdersData(businessId));
          return result.data;
        } else {
          dispatch(getManufacturingOrdersData(businessId));
          return result.data;
        }
      } else {
        throw new Error(
          result.data?.error || "Failed to create manufacturing order"
        );
      }
    } catch (error) {
      console.error("Error creating manufacturing order:", error);
      console.error("Error response:", error.response);

      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Failed to create manufacturing order";

      dispatch(setManufacturingIsLoading(false));
      throw new Error(errorMessage);
    } finally {
      dispatch(setManufacturingIsLoading(false));
    }
  };
};

export const updateManufacturingOrderData = (
  businessId,
  manufacturingId,
  data
) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      console.log("🔄 API CALL - Sending data:", data.rawMaterials);

      const result = await updateManufacturingOrder(
        businessId,
        manufacturingId,
        data
      );

      console.log("✅ API RESPONSE - Received:", result.data);

      if (result.status === 200) {
        dispatch(setManufacturingIsLoading(false));
        return result.data;
      } else {
        throw new Error(`Update failed with status: ${result.status}`);
      }
    } catch (error) {
      console.error("❌ API ERROR:", error);
      dispatch(setManufacturingIsLoading(false));
      throw error;
    }
  };
};

// Delete Manufacturing Order
export const deleteManufacturingOrderData = (businessId, manufacturingId) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await deleteManufacturingOrder(
        businessId,
        manufacturingId
      );
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      console.error("Error deleting manufacturing order:", error);
      dispatch(setManufacturingIsLoading(false));
      throw error;
    }
  };
};

// Start Manufacturing Process
export const startManufacturingProcess = (businessId, manufacturingId) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await startManufacturing(businessId, manufacturingId);
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      console.error("Error starting manufacturing:", error);
      dispatch(setManufacturingIsLoading(false));
      throw error;
    }
  };
};

// Complete Manufacturing Process
export const completeManufacturingProcess = (
  businessId,
  manufacturingId,
  data = {}
) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await completeManufacturing(
        businessId,
        manufacturingId,
        data
      );
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      console.error("Error completing manufacturing:", error);
      dispatch(setManufacturingIsLoading(false));
      throw error;
    }
  };
};

// Get Available Raw Materials
export const getAvailableRawMaterialsData = (businessId) => {
  return async (dispatch) => {
    dispatch(setAvailableRawMaterialsLoading(true));
    try {
      const result = await getAvailableRawMaterials(businessId);
      if (result.status === 200) {
        dispatch(setAvailableRawMaterials(result.data.data));
      }
    } catch (error) {
      console.error("Error fetching available raw materials:", error);
      dispatch(setAvailableRawMaterialsLoading(false));
    }
  };
};

// Get Production Efficiency
export const getProductionEfficiencyData = (
  businessId,
  timePeriod = "month"
) => {
  return async (dispatch) => {
    try {
      const result = await getProductionEfficiency(businessId, timePeriod);
      if (result.status === 200) {
        dispatch(setEfficiencyStats(result.data));
      }
    } catch (error) {
      console.error("Error fetching production efficiency:", error);
    }
  };
};

// Get Pending Productions
export const getPendingProductionsData = (businessId) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await getPendingProductions(businessId);
      if (result.status === 200) {
        dispatch(setManufacturingOrders(result.data));
        dispatch(setTempManufacturingOrders(result.data));
      }
    } catch (error) {
      console.error("Error fetching pending productions:", error);
      dispatch(setManufacturingIsLoading(false));
    }
  };
};

// Get Productions by Status
export const getProductionsByStatusData = (businessId, status) => {
  return async (dispatch) => {
    dispatch(setManufacturingIsLoading(true));
    try {
      const result = await getProductionsByStatus(businessId, status);
      if (result.status === 200) {
        dispatch(setManufacturingOrders(result.data));
        dispatch(setTempManufacturingOrders(result.data));
      }
    } catch (error) {
      console.error("Error fetching productions by status:", error);
      dispatch(setManufacturingIsLoading(false));
    }
  };
};

// Add manufacturing order to state after successful creation
export const addManufacturingOrderToState = (order) => {
  return (dispatch) => {
    dispatch(addManufacturingOrder(order));
  };
};

// Delete manufacturing order from state
export const deleteManufacturingOrderFromState = (index) => {
  return (dispatch) => {
    dispatch(deleteManufacturingOrderAction({ index }));
  };
};

export const deleteRawMaterialAction =
  (businessId, rawMaterialId) => async (dispatch, getState) => {
    try {
      dispatch(setRawMaterialsLoading(true));
      await deleteRawMaterialService(businessId, rawMaterialId);
      const state = getState();
      const index = state.RawMatarial.rawMaterials.findIndex(
        (rm) => rm.rawMaterialId === rawMaterialId
      );
      if (index !== -1) {
        dispatch(deleteRawMaterial({ index }));
      }
      toast.success("Raw material deleted successfully");
    } catch (error) {
      toast.error("Failed to delete raw material");
      console.error("Delete raw material error:", error);
    } finally {
      dispatch(setRawMaterialsLoading(false));
    }
  };

export const getWarehouseProductsData = (businessId) => {
  return async (dispatch) => {
    dispatch(setWarehouseProductsLoading(true));
    try {
      const result = await getWarehouseProducts(businessId);
      if (result.status === 200) {
        dispatch(setWarehouseProducts(result.data));
      }
    } catch (error) {
      console.error("Error fetching warehouse products:", error);
      dispatch(setWarehouseProductsLoading(false));
    }
  };
};

// ========================================
// EXISTING CORE ACTIONS
// ========================================

export const getListsData = (bId) => {
  return async (dispatch) => {
    dispatch(setListIsLoading());
    const result = await getAllLists(bId);
    if (result.status === 200) {
      dispatch(setLists(result.data));
    }
  };
};

export const getSalesData = (bussinessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(setSaleIsLoading());
    const result = await getSales(bussinessUuid, params);
    if (result?.status === 200) {
      dispatch(setSales(result.data.data));
      dispatch(setTempSales(result.data.data));
      dispatch(setSalePagination(result.data.pagination));
    }
  };
};

export const addReturnData = (bussinessUuid) => {
  return async (dispatch) => {
    dispatch(setSaleIsLoading());
    const result = await createSale(bussinessUuid);
    if (result.status === 200) {
      dispatch(addSale(result.data));
      dispatch(setTempSales(result.data));
    }
  };
};

export const addReturns = async (businessId, data) => {
  return async (dispatch) => {
    dispatch(setSaleIsLoading());
    const result = await createReturn(businessId, data);
    console.log("Line no 181", result);
  };
};

export const getReturnData = (bussinessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(setSaleIsLoading());
    const result = await getReturns(bussinessUuid, params);
    if (result.status === 200) {
      dispatch(setReturns(result.data.data));
      dispatch(setTempReturn(result.data.data));
      dispatch(setSaleReturnPagination(result.data.pagination));
    }
  };
};

export const getBuysData = (bussinessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(setBuyIsLoading());
    const result = await getBuys(bussinessUuid, params);
    if (result.status === 200) {
      dispatch(setBuys(result.data.data));
      dispatch(setTempBuys(result.data.data));
      dispatch(setBuyPagination(result.data.pagination));
    }
  };
};

export const getProductsData = (bussinessUuid) => {
  return async (dispatch) => {
    dispatch(setBuyIsLoading());
    const result = await getInventoryProducts(bussinessUuid);
    if (result.status === 200) {
      dispatch(setProducts(result.data));
    }
  };
};

export const addBuysData = () => {
  return async (dispatch) => {
    dispatch(setBuyIsLoading());
    const result = await createBuy();
    if (result.status === 200) {
      dispatch(addBuy(result.data));
      dispatch(setTempBuys(result.data));
    }
  };
};

export const getExpensesData = (bussinessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(setExpenseIsLoading());
    const result = await getExpenses(bussinessUuid, params);
    if (result.status === 200) {
      dispatch(setExpenses(result.data.data));
      dispatch(setTempExpenses(result.data.data));
      dispatch(setExpensePagination(result.data.pagination));
    }
  };
};

export const getCashBookData = (bussinessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setCashBookIsLoading());
    const result = await getAlltransaction(bussinessId, params);
    if (result.status === 200) {
      dispatch(setCashBooks(result.data.data));
      dispatch(setTempCashBooks(result.data.data));
      dispatch(setCashBooksPagination(result.data.pagination));
    }
  };
};

export const getCustomersData = (businessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setCustomerIsLoading());
    const result = await getCustomer(businessId, params);
    if (result.status === 200) {
      dispatch(setCustomers(result.data.data));
      dispatch(setTempCustomers(result.data.data));
      dispatch(setCustomerPagination(result.data.pagination));
    }
  };
};

export const getSuppliersData = (bussinessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(setSupplierIsLoading());
    const result = await getSuplier(bussinessUuid, params);
    if (result.status === 200) {
      dispatch(setSuppliers(result.data.data));
      dispatch(setTempSuppliers(result.data.data));
      dispatch(setSupplierPagination(result.data.pagination));
    }
  };
};

export const getEmployeesData = (businessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setEmployeeIsLoading());
    const result = await getEmployee(businessId, params);
    if (result.status === 200) {
      dispatch(setEmployees(result.data.data));
      dispatch(setTempEmployees(result.data.data));
      dispatch(setEmployeePagination(result.data.pagination));
    }
  };
};

export const getInventoryData = (bussinessUuid, params = {}) => {
  console.log("getInventoryData: Started fetching for business:", bussinessUuid);
  return async (dispatch) => {
    if (!bussinessUuid || bussinessUuid === "undefined") {
      console.warn("getInventoryData: Missing or invalid bussinessUuid", bussinessUuid);
      return;
    }

    dispatch(setInventoryIsLoading());
    try {
      const [productsRes, servicesRes, rawMaterialsRes] = await Promise.all([
        getProducts(bussinessUuid, params).catch(e => { console.error("Error fetching products", e); return { data: [], status: 500 }; }),
        getServices(bussinessUuid, params).catch(e => { console.error("Error fetching services", e); return { data: [], status: 500 }; }),
        getRawmatrial(bussinessUuid, params).catch(e => { console.error("Error fetching raw materials", e); return { data: [], status: 500 }; }),
      ]);
      const productsData = productsRes?.data || [];
      const servicesData = servicesRes?.data || [];
      const rawMaterialsData = rawMaterialsRes?.data || [];

      dispatch(
        setInventory({
          products: productsData,
          services: servicesData,
          rawMaterials: rawMaterialsData,
        })
      );

      if (!params.all) {
        if (productsData?.pagination) dispatch(setProductsPagination(productsData.pagination));
        if (servicesData?.pagination) dispatch(setServicePagination(servicesData.pagination));
        if (rawMaterialsData?.pagination) dispatch(setRawMaterialsPagination(rawMaterialsData.pagination));
      }
      dispatch(setTempProducts(productsData?.data || productsData));
      dispatch(setTempServices(servicesData?.data || servicesData));
      dispatch(setTempRawMaterials(rawMaterialsData?.data || rawMaterialsData));
      console.log("getInventoryData: API call completed successfully");
      
    } catch (error) {
      console.error("Critical error in getInventoryData:", error);
      dispatch(setInventory({ products: [], services: [], rawMaterials: [] }));
    } finally {
      dispatch(setInventoryIsLoadingFalse());
    }
  };
};

export const getDashboardData = (businessId, startDate, endDate) => {
  return async (dispatch) => {
    try {
      dispatch(setDashboardIsLoading());
      
      const result = await getStatsData(businessId, startDate, endDate);
      
      if (result.status === 200) {
        dispatch(setStates(result.data));
        return result.data;
      } else {
        console.error("Failed to fetch dashboard data:", result);
        dispatch(setDashboardError(result.data?.error || "Failed to fetch data"));
        return null;
      }
    } catch (error) {
      console.error("Error in getDashboardData:", error);
      dispatch(setDashboardError(error.message || "An error occurred"));
      return null;
    }
  };
};

export const getDashboardTasksData = (businessId) => {
  return async (dispatch) => {
    try {
      const result = await getAllTodosTasks(businessId);
      if (result.status === 200) {
        dispatch(setTasks(result.data));
        return result.data;
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      return null;
    }
  };
};

export const updateUsersData = async (id, data) => {
  return async (dispatch) => {
    dispatch(setUserLoading());
    console.log("line no 163");
    const result = await updateUser(id, data);
    console.log("Line no 17result", result);
    if (result.status === 200) {
      dispatch(updateUsers(result.data));
    }
  };
};

export const addProducts = (bussinessUuid, data) => {
  return async (dispatch) => {
    dispatch(setInventoryIsLoading());
    try {
      const result = await createProducts(bussinessUuid, data);
      if (result.status === 200 || result.status === 201) {
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setInventory({ products: [], services: [], rawMaterials: [] }));
    }
  };
};

export const getUsersData = (id) => {
  return async (dispatch) => {
    dispatch(setUserLoading());
    const result = await getUser(id);
    if (result.status === 200) {
      console.log("Line no 221", result.data);
      dispatch(updateUsers(result.data));
    }
  };
};

export const getAllPurchaseReturnData = (businessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setBuyIsLoading());
    const result = await getAllPurchaseReturnService(businessId, params);
    if (result.status === 200) {
      dispatch(setPurchaseReturns(result.data.data));
      dispatch(setTempPurchaseReturn(result.data.data));
      dispatch(setBuyReturnPagination(result.data.pagination));
    }
  };
};

export const getIncomeData = (bussinessUuid, params = {}) => {
  return async (dispatch) => {
    dispatch(setIncomeIsLoading());
    const result = await getIncomeService(bussinessUuid, params);
    if (result.status === 200) {
      dispatch(setIncome(result.data.data));
      dispatch(setTempIncome(result.data.data));
      dispatch(setIncomePagination(result.data.pagination));
    }
  };
};

export const getDebitNotesData = (bussinessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setDebitIsLoading());
    const result = await getDebitNotes(bussinessId, params);
    if (result.status === 200) {
      dispatch(setDebit(result.data.data));
      dispatch(setTempDebit(result.data.data));
      dispatch(setDebitPagination(result.data.pagination));
    }
  };
};

export const getCreditNotesData = (bussinessId, params = {}) => {
  return async (dispatch) => {
    dispatch(setCreditIsLoading());
    const result = await getCreditNotes(bussinessId, params);
    if (result.status === 200) {
      dispatch(setCredit(result.data.data));
      dispatch(setTempCredit(result.data.data));
      dispatch(setCreditPagination(result.data.pagination));
    }
  };
};

export const updateProductVariant = (businessId, productId, variantId, variantData) => {
  return async (dispatch, getState) => {
    try {
      const response = await updateVariant(businessId, productId, variantId, variantData);
      
      if (response.status === 200 || response.success) {
        const updatedVariant = response.data?.data || response.data || variantData;
        
        const state = getState();
        const products = state.inventory?.products?.data || state.inventory?.products || [];
        
        const productIndex = products.findIndex(p => 
          p.productId === productId || p._id === productId
        );
        
        if (productIndex !== -1) {
          const product = products[productIndex];
          const variants = product.variants || [];
          
          const variantIndex = variants.findIndex(v => 
            v.variantId === variantId || v._id === variantId
          );
          
          if (variantIndex !== -1) {
            dispatch({
              type: 'inventory/updateVariant',
              payload: {
                productId,
                variantId,
                variantIndex,
                productIndex,
                variantData: updatedVariant
              }
            });
          }
        }
        
        return { success: true, data: updatedVariant };
      } else {
        throw new Error(response.message || "Failed to update variant");
      }
    } catch (error) {
      console.error("Error updating variant:", error);
      toast.error(error.message || "Failed to update variant");
      return { success: false, error: error.message };
    }
  };
};

// Action to delete a variant
export const deleteProductVariant = (businessId, productId, variantId) => {
  return async (dispatch, getState) => {
    try {
      const response = await deleteVariant(businessId, productId, variantId);
      
      if (response.status === 200 || response.success) {
        const state = getState();
        const products = state.inventory?.products?.data || state.inventory?.products || [];
        
        const productIndex = products.findIndex(p => 
          p.productId === productId || p._id === productId
        );
        
        if (productIndex !== -1) {
          const product = products[productIndex];
          const variants = product.variants || [];
          
          const variantIndex = variants.findIndex(v => 
            v.variantId === variantId || v._id === variantId
          );
          
          if (variantIndex !== -1) {
            dispatch({
              type: 'inventory/deleteVariant',
              payload: {
                productId,
                variantId,
                variantIndex,
                productIndex
              }
            });
          }
        }
        
        return { success: true };
      } else {
        throw new Error(response.message || "Failed to delete variant");
      }
    } catch (error) {
      console.error("Error deleting variant:", error);
      toast.error(error.message || "Failed to delete variant");
      return { success: false, error: error.message };
    }
  };
};

// Action to save product variants
export const saveProductVariantsAction = (businessId, productId, variantsData) => {
  return async (dispatch, getState) => {
    try {
      const response = await saveProductVariants(businessId, productId, variantsData);
      
      if (response.status === 200 || response.status === 201 || response.success) {
        const savedVariants = response.data?.data?.variants || variantsData.variants || [];
        
        const state = getState();
        const products = state.inventory?.products?.data || state.inventory?.products || [];
        
        const productIndex = products.findIndex(p => 
          p.productId === productId || p._id === productId
        );
        
        if (productIndex !== -1) {
          dispatch({
            type: 'inventory/setProductVariants',
            payload: {
              productId,
              productIndex,
              variants: savedVariants
            }
          });
        }
        
        toast.success("Variants saved successfully");
        return { success: true, data: savedVariants };
      } else {
        throw new Error(response.message || "Failed to save variants");
      }
    } catch (error) {
      console.error("Error saving variants:", error);
      toast.error(error.message || "Failed to save variants");
      return { success: false, error: error.message };
    }
  };
};

export const getBussinessData = (bussinessUuid) => {
  return async (dispatch) => {
    dispatch(setBusinessLoading());
    const result = await getBusiness(bussinessUuid);
    if (result && result.status === 200) {
      dispatch(getBusines(result.data));
    }
  };
};

export const getCouponData = (bussinessUuid) => {
  return async (dispatch) => {
    dispatch(setCouponLoading());
    const result = await getCoupons(bussinessUuid);
    dispatch(setCoupons(result.data.coupons));
  };
};

export const fetchTickets = (bussinessUuid) => async (dispatch) => {
  try {
    dispatch(fetchTicketsStart());
    const response = await getAllTickets(bussinessUuid);
    dispatch(fetchTicketsSuccess(response.data));
  } catch (error) {
    dispatch(fetchTicketsFailure(error.message));
  }
};

export const addNote = (bussinessUuid, ticketId, note) => async (dispatch) => {
  try {
    await addTicketNoteService(bussinessUuid, ticketId, { message: note });
    dispatch(addNoteToTicket({ ticketId, note }));
  } catch (error) { }
};

export const fetchInitializePermissions = (businessUuid) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const result = await initializePermissions(businessUuid);
      dispatch(setPermissions(result.data));
    } catch (error) {
      dispatch(setError(error.message));
    }
  };
};

export const fetchAllRolePermissions = (businessUuid) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const result = await getAllRolePermissions(businessUuid);
      console.log("Fetched role permissions:", result.data);
      dispatch(setPermissions(result.data));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const fetchUserAllowedRoutes = (businessUuid) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const result = await getUserAllowedRoutes(businessUuid);
      console.log("Fetched allowed routes:", result.data);
      dispatch(setAllowedRoutes(result.data));
    } catch (error) {
      console.error("Error fetching allowed routes:", error);
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const saveRolePermissions = (role, permissions, businessUuid) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const result = await updateRolePermissions(
        role,
        permissions,
        businessUuid
      );
      dispatch(setPermissions(result.data));
      return result.data;
    } catch (error) {
      dispatch(setError(error.message));
      throw error;
    }
  };
};

export const fetchDeliveryData = (bussinessUuid) => {
  return async (dispatch) => {
    dispatch(setDeliveryIsLoading());
    try {
      const result = await delivarydata(bussinessUuid);
      if (result.status === 200) {
        dispatch(setDeliveryData(result.data));
      }
    } catch (error) {
      console.error("Failed to fetch delivery data:", error);
      dispatch(setDeliveryIsLoading(false));
    }
  };
};

export const fetchPnLData =
  (businessId, requiredKeys = []) =>
    async (dispatch) => {
      dispatch(fetchPnLDataRequest());

      try {
        const response = await PandLReportBasicFormat(businessId, requiredKeys);
        dispatch(fetchPnLDataSuccess(response.data));
      } catch (error) {
        dispatch(fetchPnLDataFailure(error.message));
      }
    };

export const fetchInventoryReoprtData = (businessId) => async (dispatch) => {
  dispatch(fetchInventoryRequest());
  try {
    const response = await fetchInventoryData(businessId);
    dispatch(fetchInventorySuccess(response.data.data));
  } catch (error) {
    dispatch(fetchInventoryFailure(error.message));
  }
};

export const BasicPnlReport =
  (businessId, timeRange, customFromDate, customToDate) => async (dispatch) => {
    dispatch(BasicPnLDataRequest());

    try {
      if (timeRange === "Other") {
        if (!customFromDate || !customToDate) {
          throw new Error(
            "Both from and to dates are required for custom range"
          );
        }

        if (customToDate < customFromDate) {
          throw new Error("To date must be after from date");
        }
      }

      const params = {
        timeRange: timeRange === "Other" ? "custom" : timeRange,
        ...(timeRange === "Other" && {
          customFromDate: format(customFromDate, "dd-MM-yyyy"),
          customToDate: format(customToDate, "dd-MM-yyyy"),
        }),
      };

      const response = await PnlBasic(businessId, params);
      dispatch(BasicPnLDataSuccess(response.data));
    } catch (error) {
      dispatch(BasicPnLDataFailure(error.message));
    }
  };

export const fetchPnlTrendData = (businessId, params = {}) => {
  return async (dispatch) => {
    dispatch(PnlTrendRequest());
    try {
      const response = await PnlTrend(businessId, params);
      if (response.data.success) {
        dispatch(PnlTrendSuccess(response.data.data));
      } else {
        dispatch(PnlTrendFailure(response.data.message));
      }
    } catch (error) {
      dispatch(PnlTrendFailure(error.message));
    }
  };
};

export const fetchCustomerPending =
  (businessId, params) => async (dispatch) => {
    try {
      dispatch(CustomerPendingRequest());
      const resp = await PnlCustomerPending(businessId, params);
      dispatch(CustomerPendingSuccess(resp.data.data));
    } catch (error) {
      dispatch(CustomerPendingFailure(error.message || "Something went wrong"));
    }
  };

export const fetchSupplierPendingData = (businessId, params = {}) => {
  return async (dispatch) => {
    dispatch(supplierPendingRequest());

    try {
      const response = await getSupplierPending(businessId, params);

      if (response.data && response.data.success) {
        dispatch(supplierPendingSuccess(response.data.data));
      } else {
        dispatch(
          supplierPendingFailure(
            response.data?.message || "Failed to fetch supplier pending data"
          )
        );
      }
    } catch (error) {
      console.error("Error in fetchSupplierPendingData:", error);
      dispatch(
        supplierPendingFailure(error.message || "Network error occurred")
      );
    }
  };
};

export const fetchSalesReport = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(salesReportRequest());

      const response = await customeSalesReport(businessId, filters);

      if (response.data && response.data.success) {
        dispatch(salesReportSuccess(response.data));
      } else {
        dispatch(
          salesReportFailure(
            response.data?.message || "Failed to fetch sales report"
          )
        );
      }
    } catch (error) {
      dispatch(
        salesReportFailure(
          error.message || "An error occurred while fetching sales report"
        )
      );
    }
  };
};

export const fetchPurchaseReport = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(purchesReportRequest());

      const response = await customePurchaseReport(businessId, filters);

      if (response.data && response.data.success) {
        dispatch(purchesReportSuccess(response.data));
      } else {
        dispatch(
          purchesReportFailure(
            response.data?.message || "Failed to fetch purchase report"
          )
        );
      }
    } catch (error) {
      dispatch(
        purchesReportFailure(
          error.message || "An error occurred while fetching purchase report"
        )
      );
    }
  };
};

export const fetchInventoryReport = (businessId, params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(inventoryReportRequest());

      const response = await getInventoryReport(businessId, params);

      if (response.data.success) {
        dispatch(inventoryReportSuccess(response.data));
      } else {
        dispatch(
          inventoryReportFailure(
            response.data.message || "Failed to fetch inventory report"
          )
        );
      }

      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Network error";
      dispatch(inventoryReportFailure(errorMessage));
      throw error;
    }
  };
};

export const fetchExpenseReport = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(expenseReportRequest());

      const response = await getExpenseReport(businessId, filters);

      if (response.data.success) {
        dispatch(expenseReportSuccess(response.data));
      } else {
        dispatch(
          expenseReportFailure(
            response.data.message || "Failed to fetch expense report"
          )
        );
      }
    } catch (error) {
      dispatch(
        expenseReportFailure(
          error.response?.data?.message || error.message || "Network error"
        )
      );
    }
  };
};

export const fetchCustomerReport =
  (businessId, filters = {}) =>
    async (dispatch) => {
      try {
        dispatch(customerReportRequest());
        const response = await getCustomerReport(businessId, filters);
        dispatch(customerReportSuccess(response.data));
      } catch (error) {
        dispatch(customerReportFailure(error.message));
      }
    };

export const fetchSupplierReport =
  (businessId, filters = {}) =>
    async (dispatch) => {
      try {
        dispatch(supplierReportRequest());
        const response = await getSupplierReport(businessId, filters);
        dispatch(supplierReportSuccess(response.data));
      } catch (error) {
        dispatch(supplierReportFailure(error.message));
      }
    };

export const fetchSalesTrendReport =
  (businessId, filters = {}) =>
    async (dispatch) => {
      try {
        dispatch(salesTrendReportRequest());
        const response = await getSalesTrendReport(businessId, filters);
        dispatch(salesTrendReportSuccess(response.data));
      } catch (error) {
        dispatch(
          salesTrendReportFailure(
            error.message || "Failed to fetch sales trend report"
          )
        );
      }
    };

export const fetchSaleReportByPercent = (businessId, params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(saleReportByPercentRequest(params));

      const response = await getSaleReportByPercent(businessId, params);

      if (response.success) {
        dispatch(saleReportByPercentSuccess(response));
      } else {
        dispatch(
          saleReportByPercentFailure(
            response.message || "Failed to fetch sale report"
          )
        );
      }
    } catch (error) {
      dispatch(saleReportByPercentFailure(error.message || "Network error"));
    }
  };
};

export const fetchTrendReport =
  (businessId, filters = {}) =>
    async (dispatch) => {
      dispatch(trendReportRequest());
      const {
        timeRange,
        customFromDate,
        customToDate,
        viewMode,
        ...otherFilters
      } = filters;

      const params = {
        viewMode: viewMode || "product",
        ...(customFromDate && { startDate: customFromDate }),
        ...(customToDate && { endDate: customToDate }),
        ...otherFilters,
      };

      try {
        const response = await getTrendReport(businessId, params);
        if (response.success) {
          dispatch(trendReportSuccess(response));
        } else {
          dispatch(trendReportFailure(response.message || "Unknown error"));
        }
      } catch (error) {
        dispatch(trendReportFailure(error.toString()));
      }
    };

export const fetchSalesInvoiceReport = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(salesInvoiceReportRequest());
      const response = await getSalesInvoiceReport(businessId, filters);
      dispatch(salesInvoiceReportSuccess(response));
    } catch (error) {
      console.error("Error in fetchSalesInvoiceReport:", error);
      dispatch(salesInvoiceReportFailure(error.message));
    }
  };
};

export const fetchReturnTrendReport = (businessId, params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(returnTrendReportRequest());

      const response = await getReturnTrendReport(businessId, params);

      if (response.success) {
        dispatch(returnTrendReportSuccess(response.data));
      } else {
        dispatch(
          returnTrendReportFailure(
            response.message || "Failed to fetch return trend report"
          )
        );
      }
    } catch (error) {
      console.error("Error in fetchReturnTrendReport:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch return trend report";

      dispatch(returnTrendReportFailure(errorMessage));
    }
  };
};

export const fetchReturnPercentageReport = (businessId, params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(returnPercentageReportRequest());

      const response = await getReturnByPercentageReport(businessId, params);

      if (response.success) {
        dispatch(returnPercentageReportSuccess(response.data));
      } else {
        dispatch(
          returnPercentageReportFailure(
            response.message || "Failed to fetch return percentage report"
          )
        );
      }
    } catch (error) {
      console.error("Error in fetchReturnPercentageReport:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to fetch return percentage report";

      dispatch(returnPercentageReportFailure(errorMessage));
    }
  };
};

export const fetchCustomerPurchaseReport = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(customerPurchaseReportRequest());

      const response = await getCustomerReportcustomer(businessId, filters);

      dispatch(customerPurchaseReportSuccess(response));
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch customer purchase report";
      console.error("Error in fetchCustomerPurchaseReport:", errorMessage);
      dispatch(customerPurchaseReportFailure(errorMessage));
    }
  };
};

export const fetchPurchaseDetailedReport = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(purchaseReportRequest());

      const response = await getPurchaseDetailedReport(businessId, filters);

      dispatch(purchaseReportSuccess(response));
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch purchase detailed report";
      console.error("Error in fetchPurchaseDetailedReport:", errorMessage);
      dispatch(purchaseReportFailure(errorMessage));
    }
  };
};

export const fetchPurchaseStatusDetailedReport = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(purchaseStatusReportRequest());

      const response = await getPurchaseStatusDetailedReport(
        businessId,
        filters
      );

      dispatch(purchaseStatusReportSuccess(response));
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch purchase status detailed report";
      console.error(
        "Error in fetchPurchaseStatusDetailedReport:",
        errorMessage
      );
      dispatch(purchaseStatusReportFailure(errorMessage));
    }
  };
};

// Action to fetch GSTR1 report data
export const fetchGstr1Report = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(Gstr1ReportRequest());

      const response = await gstr1report(businessId, filters);

      dispatch(Gstr1ReportSuccess(response));
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "Failed to fetch GSTR1 report";
      console.error("Error in fetchGstr1Report:", errorMessage);
      dispatch(Gstr1ReportFailure(errorMessage));
    }
  };
};

export const fetchGstr2Report = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(Gstr2ReportRequest());

      const response = await gstr2report(businessId, filters);

      dispatch(Gstr2ReportSuccess(response));
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "Failed to fetch GSTR1 report";
      console.error("Error in fetchGstr1Report:", errorMessage);
      dispatch(Gstr2ReportFailure(errorMessage));
    }
  };
};

export const fetchGstr3BReport = (businessId, filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch(Gstr3BReportRequest());

      const response = await getGSTR3BReport(businessId, filters);

      dispatch(Gstr3BReportSuccess(response.data));
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "Failed to fetch GSTR 3B report";
      console.error("Error in fetchGstr3BReport:", errorMessage);
      dispatch(Gstr3BReportFailure(errorMessage));
    }
  };
};

export const fetchExpenseTrendData =
  (businessId, filters) => async (dispatch) => {
    dispatch(fetchExpenseTrendRequest());
    try {
      const result = await getExpenseTrendReport(businessId, filters);
      if (result.success) {
        dispatch(fetchExpenseTrendSuccess(result.data));
      } else {
        dispatch(
          fetchExpenseTrendFailure(result.message || "Failed to load report")
        );
      }
    } catch (err) {
      dispatch(fetchExpenseTrendFailure(err.toString()));
    }
  };

// ========================================
// VARIANT SELECTION ACTIONS
// ========================================

// Action to load variants for selection modal
export const loadVariantsForSelection = (businessUuid, product) => {
  return async (dispatch, getState) => {
    if (!product?.productId || !businessUuid) return;

    dispatch(setVariantSelectionLoading(true));
    dispatch(setVariantSelectionError(null));

    try {
      if (product.variants && product.variants.length > 0) {
        const inStockVariants = product.variants.filter(variant => 
          (variant.quantity || 0) > 0
        );
        dispatch(setAvailableVariants(inStockVariants));
        
        const state = getState();
        const currentSelected = state.inventory.variantSelection.selectedVariant;
        
        if (inStockVariants.length > 0 && !currentSelected) {
          dispatch(setSelectedVariant(inStockVariants[0]));
          dispatch(setSelectedQuantity(1));
        }
      } else {
        try {
          const response = await getVariantOptions(businessUuid, product.productId);
          
          if (response?.status === 200 && response.data) {
            const variants = response.data.variants || response.data.data?.variants || response.data;
            
            if (Array.isArray(variants)) {
              const inStockVariants = variants.filter(variant => 
                (variant.quantity || 0) > 0
              );
              dispatch(setAvailableVariants(inStockVariants));
              
              const state = getState();
              const currentSelected = state.inventory.variantSelection.selectedVariant;
              
              if (inStockVariants.length > 0 && !currentSelected) {
                dispatch(setSelectedVariant(inStockVariants[0]));
                dispatch(setSelectedQuantity(1));
              }
            }
          }
        } catch (fetchError) {
          console.log("Could not fetch variants from API", fetchError);
          dispatch(setAvailableVariants([]));
        }
      }
    } catch (error) {
      console.error("Error loading variants:", error);
      dispatch(setVariantSelectionError("Failed to load variants"));
      toast.error("Failed to load variants");
    } finally {
      dispatch(setVariantSelectionLoading(false));
    }
  };
};

// Action to select a variant
export const selectVariant = (variant) => (dispatch) => {
  dispatch(setSelectedVariant(variant));
};

// Action to update quantity
export const updateSelectedQuantity = (quantity) => (dispatch, getState) => {
  const state = getState();
  const selectedVariant = state.inventory.variantSelection.selectedVariant;
  
  if (selectedVariant && quantity > selectedVariant.quantity) {
    toast.error(`Only ${selectedVariant.quantity} units available`);
    return;
  }
  
  if (quantity < 1) {
    toast.error("Quantity must be at least 1");
    return;
  }
  
  dispatch(setSelectedQuantity(quantity));
};

// Action to confirm variant selection
export const confirmVariantSelection = (currentIndex, onSelectVariant, onClose) => {
  return (dispatch, getState) => {
    const state = getState();
    const { selectedVariant, selectedQuantity } = state.inventory.variantSelection;
    
    if (!selectedVariant) {
      toast.error("Please select a variant");
      return;
    }
    
    if (selectedQuantity < 1) {
      toast.error("Quantity must be at least 1");
      return;
    }
    
    if (selectedQuantity > selectedVariant.quantity) {
      toast.error(`Only ${selectedVariant.quantity} units available for this variant`);
      return;
    }
    
    onSelectVariant(selectedVariant, selectedQuantity, currentIndex);
    dispatch(resetVariantSelection());
    onClose();
  };
};

// Action to reset variant selection
export const resetVariantSelectionState = () => (dispatch) => {
  dispatch(resetVariantSelection());
};

export const clearWishlistState = () => (dispatch) => {
  dispatch(resetWishlistState());
};